import { createSlice } from "@reduxjs/toolkit"

const companySlice = createSlice({
    name: "chargingSessions",
    initialState: {
        showColumns: [],
    },
    reducers: {
        setShowColumns: (state, { payload: { columns } }) => {
            state.showColumns = columns
        },
    },
})
export const { setShowColumns } = companySlice.actions
export default companySlice.reducer
